import { NgModule } from '@angular/core';
import { PtcSuggestionsSearchProvider } from './providers/ptc.suggestions.search.provider';
import { SuggestionsSearchProvider } from '@nrwl/smart-search';
import {
  KeywordToResourceResolver,
  QueryEmitterServicesProvider,
  QueryExpressionParserService,
  StrictSqlWhereParserService,
  ValueAdapterProvider
} from '@nrwl/query-emitter';
import { PtcValueAdapterProvider } from './providers/ptc.value.adapter.provider';
import { AtwebQueryExpressionParserService } from './providers/atweb-query-expression-parser.service';
import { PtcKeywordToResourceResolver } from './providers/ptc.keyword.to.resource.resolver';
import { ReportsQueryExpressionParserService } from './providers/reports.query.expression.parser.service';
import { SqlExpressionParserService } from './providers/sql.expression.parser.service';
import { PtcQueryEmitterServicesProvider } from './providers/ptc.query.emitter.services.provider';

@NgModule({
  imports: [],
  providers: [
    AtwebQueryExpressionParserService,
    PtcSuggestionsSearchProvider,

    {
      provide: SuggestionsSearchProvider,
      useClass: PtcSuggestionsSearchProvider
    },
    {
      provide: QueryExpressionParserService,
      useClass: ReportsQueryExpressionParserService // has broader syntax capabilities than AtwebQueryExpressionParserService
    },
    {
      provide: StrictSqlWhereParserService,
      useClass: SqlExpressionParserService // requires strict match to  SQL syntax
    },
    {
      provide: ValueAdapterProvider,
      useClass: PtcValueAdapterProvider
    },
    {
      provide: KeywordToResourceResolver,
      useClass: PtcKeywordToResourceResolver
    },
    {
      // convenience class to wrap many implementations under one cover
      provide: QueryEmitterServicesProvider,
      useClass: PtcQueryEmitterServicesProvider
    }
  ]
})
export class AtwebQueryModule {}
